var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":""},on:{"click":_vm.onClick,"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp}},[_c('v-icon',[_vm._v(_vm._s(_vm.iconName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }